import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from 'express';
import { AuthService } from '../authentication/authentication.service';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private http: HttpClient) { }

  createTicket(ticketForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'ticket/submit_ticket', ticketForm, OPTIONS);
  }

  getRequestType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'ticket/get_request_type', OPTIONS);
  }

  getSubmittedTickets() {
    return this.http.get<any>(Library.API_ENDPOINT + 'ticket/get_submitted_tickets', OPTIONS);
  }
}
